export default "__VITE_ASSET__e72ad94d__"